import { render, staticRenderFns } from "./PriceConfig.vue?vue&type=template&id=ba76c680"
import script from "./PriceConfig.vue?vue&type=script&lang=js"
export * from "./PriceConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports